<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-container fluid>
            <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
                <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
                <v-btn dark text @click="snackbar = false">Close</v-btn>
            </v-snackbar>
            <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>

            <v-card class="box">
                <v-toolbar flat dense class="toolbar">
                    <v-toolbar-title>Receipt Details Report</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-row justify="center" dense>
                    <v-col cols="12" sm="2">
                        <p><v-icon color="error">*</v-icon><b>Academic Year</b></p>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="ay" :items="ay_list"
                            item-text="ay" item-value="id" label="Academic Year" outlined persistent-hint
                            hint="Please Select Academic Year" />
                    </v-col>
                    <v-col cols="12" sm="2">
                        <p><v-icon color="error">*</v-icon><b>Section</b></p>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="section" :items="section_list"
                            item-text="name" item-value="id" label="Section" @change="getStandardBySection()" outlined
                            persistent-hint hint="Please Select Section" />
                    </v-col>
                    <v-col cols="12" sm="2" v-if="this.standard_list.length > 0">
                        <p><v-icon color="error">*</v-icon><b>Standard</b></p>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="standard" :items="standard_list"
                            item-text="standard" item-value="id" label="Standard" outlined persistent-hint
                            hint="Please Select Standard" />
                    </v-col>
                    <v-col cols="12" sm="2" v-if="this.division_offering_list.length > 0">
                        <p><v-icon color="error">*</v-icon><b>Division</b></p>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="division"
                            :items="division_offering_list" item-text="division" item-value="id" label="Division"
                            outlined persistent-hint hint="Please Select Division" />
                    </v-col>
                    <!-- <v-col cols="12" sm="2">
                        <p><b>From Date*</b></p>
                        <v-menu ref="menu1" v-model="menu1" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="290px">
                            <template v-slot:activator="{ on }">
                                <v-text-field outlined rounded  dense v-model="selected_date" @blur="date = parseDate(selected_date)" v-on="on" prepend-icon="event" persistent-hint></v-text-field>
                            </template>
                            <v-date-picker v-model="date" no-title @input="menu1 = false" :max="nowDate"></v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col cols="12" sm="2">
                        <p><b>To Date*</b></p>
                        <v-menu ref="menu2" v-model="menu2" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="290px">
                            <template v-slot:activator="{ on }">
                                <v-text-field outlined rounded dense v-model="to_date" @blur="todate = parseDate(to_date)" v-on="on" prepend-icon="event" persistent-hint></v-text-field>
                            </template>
                            <v-date-picker v-model="todate" no-title @input="menu2 = false" :max="nowDate"></v-date-picker>
                        </v-menu>
                    </v-col> -->
                    <!-- <v-col cols="12" sm="3">
                        <p><v-icon color="error">*</v-icon><b>From Date</b></p>
                        <v-menu v-model="menu11" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    persistent-hint
                                    hint="YYYY/MM/DD FORMAT INCLUSIVE"
                                    placeholder="Inclusive"
                                    color="#0F2027"
                                    v-model="date_1"
                                    outlined
                                    rounded
                                    dense
                                    label="From Date"
                                    prepend-icon="mdi-calendar"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker v-model="date_1" :max="nowDate" @input="menu11 = false"></v-date-picker>
                        </v-menu>
                        <input id="datePickerId" type="date" v-model="date_1" />
                    </v-col> -->
                    <v-col cols="12" sm="3">
                        <p><v-icon color="error">*</v-icon><b>From Date</b></p>
                        <v-menu ref="menu1" v-model="menu1" :close-on-content-click="false"
                            transition="scale-transition" offset-y max-width="290px" min-width="290px">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field v-bind="attrs" dense v-model="date_of_generation"
                                    @blur="date = parseDate(date_of_generation)" v-on="on" hint="From Date"
                                    prepend-icon="event" outlined rounded persistent-hint></v-text-field>
                            </template>
                            <v-date-picker v-model="gen_date" no-title @input="menu1 = false"></v-date-picker>
                        </v-menu>
                        <!-- <input id="datePickerId" type="date" v-model="date_2" /> -->
                    </v-col>
                    <v-col cols="12" sm="2" md="2">
                        <p><v-icon color="error">*</v-icon><b>To Date</b></p>
                        <v-menu ref="menu2" v-model="menu2" :close-on-content-click="false"
                            transition="scale-transition" offset-y max-width="290px" min-width="290px">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field v-bind="attrs" dense v-model="application_date" v-on="on"
                                    hint="To Date (inclusive)" outlined rounded prepend-icon="event"
                                    persistent-hint></v-text-field>
                            </template>
                            <v-date-picker v-model="date_of_application" no-title
                                @input="menu2 = false"></v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col cols="12" sm="2" md="2" class="mt-6">
                        <v-switch color="#0F2027" v-model="sort_date_wise" label="Sort Date Wise"></v-switch>
                    </v-col>

                    <!-- <v-col cols="12" sm="3">
                        <p><v-icon color="error">*</v-icon><b>To Date</b></p>
                        <v-menu v-model="menu2" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    color="#0F2027"
                                    persistent-hint
                                    hint="YYYY/MM/DD FORMAT EXCLUSIVE"
                                    placeholder="Exclusive"
                                    v-model="date_2"
                                    outlined
                                    rounded
                                    dense
                                    label="To Date"
                                    prepend-icon="mdi-calendar"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker :min="date_1" v-model="date_2" :max="nowDate" @input="menu2 = false"></v-date-picker>
                        </v-menu>
                        <input id="datePickerId" type="date" v-model="date_2" />
                    </v-col> -->

                    <v-col cols="12" sm="2" class="pt-4" v-if="date_1 && date_2">
                        <br />
                        <v-btn color="primary" v-if="standard_list != ''" @click="getReceiptsData()">Fetch</v-btn>
                    </v-col>
                </v-row>
            </v-card>
            <span v-if="show == true">
                <v-radio-group v-model="radios" mandatory row class="ma-2 no-display">
                    <v-radio label="Installment Receipt" value="fee" color="#0f2027"></v-radio>
                    <v-radio label="Misc Receipt" value="misc" color="#0f2027"></v-radio>
                    <v-radio label="Outstanding Receipt" value="outstanding" color="#0f2027"></v-radio>
                    <v-radio label="Transport Receipt" value="transport" color="#0f2027"></v-radio>
                </v-radio-group>
                <v-row dense>
                    <v-col cols="12" sm="1" md="1" v-if="student_receipt_details != '' && radios == 'fee'">
                        <v-btn rounded color="success" outlined
                            @click="fnExcelReport('my-table-id', 'receiptdetailedreport')" :loading="loader"><v-icon
                                color="success">mdi-export</v-icon>Export</v-btn>
                    </v-col>
                    <v-col cols="12" sm="2">
                        <v-autocomplete flat hide-details rounded dense outlined label="Standard" multiple clearable
                            :items="dataValueList('standard')" v-model="filters.standard"></v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="2">
                        <v-autocomplete flat hide-details rounded dense outlined label="Division" multiple clearable
                            :items="dataValueList('division')" v-model="filters.division"></v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="2" md="2"></v-col>
                    <v-col cols="12" sm="5" md="5" v-if="student_receipt_details != '' && radios == 'fee'">
                        <v-text-field v-model="search1" append-icon="mdi-magnify"
                            label="Search by Student name or by Registration Number" single-line
                            hide-details></v-text-field>
                    </v-col>
                </v-row>
                <!-- installment fee receipt report -->
                <div id="my-table-id">
                    <div class="scroll">
                        <v-card class="box" v-if="student_receipt_details != '' && radios == 'fee'">
                            <!-- header code -->
                            <v-simple-table></v-simple-table>
                            <div v-if="org_basic_data">
                                <v-row dense justify="center">
                                    <v-col cols="12" sm="4" md="2" v-if="org_basic_data.trust_logo && show_logo"
                                        align="center">
                                        <img :src="org_basic_data.trust_logo" alt="logo" class="trust-logo" />
                                    </v-col>
                                    <v-col cols="12" sm="4" md="8">
                                        <center>
                                            <h2>
                                                <strong>{{ org_basic_data.trust_name }}</strong>
                                            </h2>
                                            <h3>
                                                <strong>{{ org_basic_data.school_name }} </strong>
                                            </h3>
                                            <span>{{ org_basic_data.address }}</span> <br />
                                            <span>Phone :{{ org_basic_data.phone }} </span> <br />
                                            <span>Email :{{ org_basic_data.email }} </span> <br />
                                            <span>Website :{{ org_basic_data.website }} </span>
                                            <br />
                                        </center>
                                    </v-col>
                                    <v-col cols="12" sm="4" md="2" v-if="org_basic_data.school_logo && show_logo">
                                        <img :src="org_basic_data.school_logo" alt="logo" class="schl-logo" />
                                    </v-col>
                                </v-row>
                            </div>
                            <div>
                                <center>
                                    <b> <span>Daily Installment Receipt Report {{ date_of_generation }} to {{
                                            application_date }}</span></b>
                                </center>
                            </div>
                            <!-- header end -->
                            <v-simple-table class="elevation-1 mytable" v-if="student_receipt_details != ''"
                                fixed-header height="500px">
                                <template>
                                    <thead>
                                        <tr>
                                            <th>Sr. No.</th>
                                            <th>Receipt No</th>
                                            <th>Student PRN</th>
                                            <th>Student Name</th>
                                            <th>Standard</th>
                                            <th>Division</th>
                                            <th>Quota</th>
                                            <th>Gender</th>
                                            <th>Receipt Date</th>
                                            <th>Transaction Date</th>
                                            <th>Bank</th>
                                            <th>Remark</th>
                                            <th>Payment Mode</th>
                                            <th>Transaction Id</th>
                                            <th>Fee Paid</th>
                                            <th>Fine</th>
                                            <th>Total Fee Paid</th>
                                            <th v-for="(item, index) in components_details_list" :key="index">
                                                <b>{{ item.name }}</b>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <!-- <tr
                      v-for="(item, index) in student_receipt_details"
                      :key="index"
                    > -->
                                        <tr v-for="(item, index) in filteredItems" :key="index">
                                            <td>{{ item.srno }}</td>
                                            <td>
                                                <v-tooltip top color="warning">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-btn class="mt-1 mb-1" outlined rounded small color="warning"
                                                            v-bind="attrs" v-on="on" @click="
                                print(
                                  item.receipt_no,
                                  item.ay,
                                  item.registration_number
                                )
                              ">
                                                            <v-icon color="warning">mdi-printer</v-icon>
                                                            {{ item.receipt_no }}
                                                        </v-btn>
                                                    </template>
                                                    <span> Print Fee Receipt!!! </span>
                                                </v-tooltip>
                                            </td>
                                            <td>{{ item.registration_number }}</td>
                                            <td>{{ item.name }}</td>
                                            <td>{{ item.standard }}</td>
                                            <td>{{ item.division }}</td>
                                            <td>{{ item.quota }}</td>
                                            <td>{{ item.gender }}</td>
                                            <td>{{ item.receipt_date }}</td>
                                            <td>{{ item.trnsaction_date }}</td>
                                            <td>{{ item.bank }}</td>
                                            <td>{{ item.remark }}</td>
                                            <td>{{ item.payment_mode }}</td>
                                            <td>{{ item.transaction_id }}</td>
                                            <td>{{ item.total_amount }}</td>
                                            <td>{{ item.fine }}</td>
                                            <td>{{ item.total_receipt_amount }}</td>
                                            <td v-for="(
                          item1, index1
                        ) in item.studentinstallmentreceiptcomponentsdetails" :key="index1">
                                                {{ item1.amount }}
                                            </td>
                                        </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>
                        </v-card>
                        <v-card class="box" v-if="misc_receipt_details != '' && radios == 'misc'">
                            <v-row dense>
                                <v-col cols="12" sm="6" md="6">
                                    <!-- <v-btn color="success" outlined rounded>
                    <download-excel
                      class="mr-2 pb-3 pt-2"
                      :data="misc_receipt_details"
                      :fields="table_fields"
                      worksheet="Misc_Fee_Receipt_Report"
                      name="Misc_Fee_Receipt_Report.xls"
                    >
                      <v-icon dark>mdi-file-excel</v-icon> Export
                    </download-excel>
                  </v-btn> -->
                                    <v-btn rounded class="mr-2 pb-3 pt-2" color="success" outlined
                                        @click="fnExcelReport('my-table-id', 'receiptdetailedreport')"
                                        :loading="loader"><v-icon color="success">mdi-export</v-icon>Export</v-btn>
                                </v-col>
                                <v-col cols="12" sm="6" md="6">
                                    <v-text-field v-model="search" append-icon="search" label="Search" single-line
                                        hide-details></v-text-field>
                                </v-col>
                            </v-row>

                            <br />
                            <v-data-table dense :headers="headers" :items="misc_receipt_details"
                                class="elevation-1 mytable" :search="search">
                                <template v-slot:item.receipt_no="{ item }">
                                    <v-tooltip top color="warning">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn class="mt-1 mb-1" outlined rounded small color="warning"
                                                v-bind="attrs" v-on="on" @click="
                          print3(
                            item.receipt_no,
                            item.ay,
                            item.registration_number
                          )
                        ">
                                                <v-icon color="warning">mdi-printer</v-icon>
                                                {{ item.receipt_no }}
                                            </v-btn>
                                        </template>
                                        <span> Print Fee Receipt!!! </span>
                                    </v-tooltip>
                                </template>
                            </v-data-table>
                        </v-card>
                        <v-card class="box" v-if="out_receipt_details != '' && radios == 'outstanding'">
                            <v-row dense>
                                <v-col cols="12" sm="6" md="6">
                                    <!-- <v-btn color="success" outlined rounded>
                    <download-excel
                      class="mr-2 pb-3 pt-2"
                      :data="out_receipt_details"
                      :fields="table_fields_out"
                      worksheet="Outstanding_Fee_Receipt_Report"
                      name="Outstanding_Fee_Receipt_Report.xls"
                    >
                      <v-icon dark>mdi-file-excel</v-icon> Export
                    </download-excel>
                  </v-btn> -->
                                    <v-btn rounded class="mr-2 pb-3 pt-2" color="success" outlined
                                        @click="fnExcelReport('my-table-id', 'receiptdetailedreport')"
                                        :loading="loader"><v-icon color="success">mdi-export</v-icon>Export</v-btn>
                                </v-col>
                                <v-col cols="12" sm="6" md="6">
                                    <v-text-field v-model="search" append-icon="search" label="Search" single-line
                                        hide-details></v-text-field>
                                </v-col>
                            </v-row>
                            <br />
                            <v-data-table dense :headers="headers_out" :items="out_receipt_details"
                                class="elevation-1 mytable" :search="search">
                                <template v-slot:item.receipt_no="{ item }">
                                    <v-tooltip top color="warning">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn class="mt-1 mb-1" outlined rounded small color="warning"
                                                v-bind="attrs" v-on="on" @click="
                          print4(
                            item.receipt_no,
                            item.ay,
                            item.registration_number
                          )
                        ">
                                                <v-icon color="warning">mdi-printer</v-icon>
                                                {{ item.receipt_no }}
                                            </v-btn>
                                        </template>
                                        <span> Print Fee Receipt!!! </span>
                                    </v-tooltip>
                                </template>
                            </v-data-table>
                        </v-card>
                        <v-card class="box" v-if="transport_receipt_details != '' && radios == 'transport'">
                            <v-row dense>
                                <v-col cols="12" sm="6" md="6">
                                    <!-- <v-btn color="success" outlined rounded>
                    <download-excel
                      class="mr-2 pb-3 pt-2"
                      :data="transport_receipt_details"
                      :fields="table_fields_trans"
                      worksheet="Transport_Fee_Receipt_Report"
                      name="Transport_Fee_Receipt_Report.xls"
                    >
                      <v-icon dark>mdi-file-excel</v-icon> Export
                    </download-excel>
                  </v-btn> -->
                                    <v-btn rounded class="mr-2 pb-3 pt-2" color="success" outlined
                                        @click="fnExcelReport('my-table-id', 'receiptdetailedreport')"
                                        :loading="loader"><v-icon color="success">mdi-export</v-icon>Export</v-btn>
                                </v-col>
                                <v-col cols="12" sm="6" md="6">
                                    <v-text-field v-model="search" append-icon="search" label="Search" single-line
                                        hide-details></v-text-field>
                                </v-col>
                            </v-row>
                            <br />
                            <v-data-table dense :headers="headers_transport" :items="transport_receipt_details"
                                class="elevation-1 mytable" :search="search">
                                <template v-slot:item.receipt_no="{ item }">
                                    <v-tooltip top color="warning">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn class="mt-1 mb-1" outlined rounded small color="warning"
                                                v-bind="attrs" v-on="on" @click="print5(item.receipt_no, item.ay)">
                                                <v-icon color="warning">mdi-printer</v-icon>
                                                {{ item.receipt_no }}
                                            </v-btn>
                                        </template>
                                        <span> Print Fee Receipt!!! </span>
                                    </v-tooltip>
                                </template>
                            </v-data-table>
                        </v-card>
                    </div>
                </div>
            </span>
        </v-container>
    </div>
    <!-- /. root div -->
</template>
<script>
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import StudentFeeReceipts from "../OfficeStaff/StudentFeeReceipts";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
    export default {
        components: {
            "student-fee-receipts": StudentFeeReceipts,
            
            Breadcrumbs
        },
        data: () => ({
            dialog_print: false,
            dialog_details: false,
            components_details_list: [],
            // extraBreadcrumbItems: [


            // ],
            // breadcrumbClass: "breadcrumb-style1",
            loader: false,
            snackbar_msg: "",
            color: "",
            snackbar: false,
            overlay: false,
            student_receipt_details: [],
            show: false,

            sortedbyASC: true,
            search: "",
            search1: "",
            sort_date_wise: false,
            headers: [
                { text: "Receipt No", value: "receipt_no" },
                { text: "Student PRN", value: "registration_number" },
                { text: "Student Name", value: "name" },
                { text: "Quota", value: "quota" },
                { text: "Gender", value: "gender" },
                { text: "Standard", value: "standard" },
                { text: "Payment Mode", value: "mode" },
                { text: "Receipt Date", value: "date", sortable: true },
                { text: "Transaction Date", value: "date" },
                { text: "Transaction Id", value: "trxn_id" },
                { text: "Remark", value: "remark" },
                { text: "Amount", value: "amount" },
                { text: "Details", value: "purpose" },
            ],
            table_fields: {
                "Receipt No": "receipt_no",
                "Student PRN": "registration_number",
                "Student Name": "name",
                Quota: "quota",
                Gender: "gender",
                Standard: "standard",
                "Payment Mode": "mode",
                "Receipt Date": "date",
                "Transaction Date": "date",
                "Transaction Id": "trxn_id",
                Remark: "remark",
                Amount: "amount",
                Details: "purpose",
            },
            headers_out: [
                { text: "Receipt No", value: "receipt_no" },
                { text: "Student PRN", value: "registration_number" },
                { text: "Student Name", value: "name" },
                { text: "Quota", value: "quota" },
                { text: "Gender", value: "gender" },
                { text: "Standard", value: "standard" },
                { text: "Payment Mode", value: "mode" },
                { text: "Receipt Date", value: "date", sortable: true },
                { text: "Transaction Date", value: "date" },
                { text: "Transaction Id", value: "trxn_id" },
                { text: "Remark", value: "remark" },
                { text: "Amount", value: "amount" },
                { text: "Details", value: "purpose" },
            ],
            table_fields_out: {
                "Receipt No": "receipt_no",
                "Student PRN": "registration_number",
                "Student Name": "name",
                Quota: "quota",
                Gender: "gender",
                Standard: "standard",
                "Payment Mode": "mode",
                "Receipt Date": "date",
                "Transaction Date": "date",
                "Transaction Id": "trxn_id",
                Remark: "remark",
                Amount: "amount",
                Details: "purpose",
            },
            headers_transport: [
                { text: "Receipt No", value: "receipt_no", class: "my-header-style" },
                {
                    text: "Student PRN",
                    value: "registration_number",
                    class: "my-header-style",
                },
                { text: "Student Name", value: "name", class: "my-header-style" },
                { text: "Quota", value: "quota", class: "my-header-style" },
                { text: "Gender", value: "gender", class: "my-header-style" },
                { text: "Payment Mode", value: "mode" },
                { text: "Receipt Date", value: "receipt_date", sortable: true },
                { text: "Transaction Date", value: "transaction_date" },
                { text: "Transaction Id", value: "trxn_id" },
                { text: "Remark", value: "remark" },
                { text: "Amount", value: "amount" },
                { text: "Details", value: "purpose" },
            ],
            table_fields_trans: {
                "Receipt No": "receipt_no",
                "Student PRN": "registration_number",
                "Student Name": "name",
                Quota: "quota",
                Gender: "gender",
                "Payment Mode": "mode",
                "Receipt Date": "receipt_date",
                "Transaction Date": "transaction_date",
                "Transaction Id": "trxn_id",
                Remark: "remark",
                Amount: "amount",
                Details: "purpose",
            },
            selected_date: "",
            radios: null,
            to_date: "",
            date: new Date().toISOString().slice(0, 10),
            menu1: false,
            menu2: false,
            menu11: false,
            todate: null,
            nowDate: new Date().toISOString().slice(0, 10),
            registration_no: "",
            receipt_no: null,
            org_id: null,
            total_amount_received: 0,
            details_list: [],
            ay_list: [],
            ay: "",
            section_list: [],
            section: "",
            standard_list: [],
            standard: "",
            division_offering_list: [],
            out_receipt_details: [],
            misc_receipt_details: [],
            transport_receipt_details: [],
            div_off: "",
            org_basic_data: [],
            show_logo: false,
            // date2: new Date().toISOString().substr(0, 10),
            date_1: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
            modal_1: false,
            date_2: new Date().toISOString().substr(0, 10),

            //
            date_of_generation: "",
            gen_date: new Date(new Date().getFullYear(), new Date().getMonth(), 2).toISOString().substr(0, 10),
            date_of_application: new Date().toISOString().substr(0, 10),
            application_date: "",
            filters: {
                standard: [],
                division: [],                    
            },
        }),
        watch: {
            date(val) {
                this.selected_date = this.formatDate(this.date);
            },
            todate(val) {
                this.to_date = this.formatDate(this.todate);
            },
            gen_date(val) {
                this.date_of_generation = this.formatDate(this.gen_date);
            },
            date_of_application(val) {
                this.application_date = this.formatDate(this.date_of_application);
            },
        },
        methods: {
            fnExcelReport(id, name) {
                var tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
                tab_text = tab_text + "<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>";
                tab_text = tab_text + "<x:Name>Test Sheet</x:Name>";
                tab_text = tab_text + "<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>";
                tab_text = tab_text + "</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>";
                tab_text = tab_text + "<table border='1px'>";
                var exportTable = $("#" + id).clone();
                exportTable.find("input").each(function (index, elem) {
                    $(elem).remove();
                });
                tab_text = tab_text + exportTable.html();
                tab_text = tab_text + "</table></body></html>";
                var fileName = name + "_" + parseInt(Math.random() * 10000000000) + ".xls";

                //Save the file
                // var blob = new Blob([tab_text], {
                //   type: "application/vnd.ms-excel;charset=utf-8",
                // });
                // window.saveAs(blob, fileName);
                const blob = new Blob([tab_text], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
                const filename = name + ".xls";

                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    // For IE
                    window.navigator.msSaveOrOpenBlob(blob, filename);
                } else {
                    // For modern browsers
                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement("a");
                    a.href = url;
                    a.download = filename;
                    a.click();
                    window.URL.revokeObjectURL(url);
                }
            },
            getDivOffByStandard() {
                const data = {
                    section: this.section,
                    ay: this.ay,
                    standard: this.standard,
                };
                axios
                    .post("/AccountingAndFees/getDivOffByStandard", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.division_offering_list = res.data.division_offering_list;
                        } else {
                            this.showSnackbar("red", res.data.snackbar);
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                    })
                    .catch((error) => {
                        this.onerror(error);
                    })
                    .finally(() => {});
            },
            getStandardBySection() {
                const data = {
                    section: this.section,
                };
                axios
                    .post("/AccountingAndFees/getStandardBySection", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.standard_list = res.data.standard_list;
                        } else if (res.data.flag == "No") {
                            this.showSnackbar("red", res.data.snackbar);
                        } else {
                            this.showSnackbar("red", res.data.snackbar);
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                    })
                    .catch((error) => {
                        this.onerror(error);
                    })
                    .finally(() => {});
            },
            print3(receipt_no, ay, registration_number) {
                this.receipt_no = receipt_no;
                this.$session.set("receipt_no", JSON.stringify(receipt_no));
                this.$session.set("ay", JSON.stringify(ay));
                this.$session.set("registration_no", JSON.stringify(registration_number));
                // this.$router.push({
                //     name: "misc-other-exam-fees-payment-receipt",
                // });
                let routeData = this.$router.resolve({
                    name: "misc-other-exam-fees-payment-receipt",
                });
                window.open(routeData.href, "_blank");
            },
            print4(receipt_no, ay, registration_number) {
                this.receipt_no = receipt_no;
                this.$session.set("receipt_no", JSON.stringify(receipt_no));
                this.$session.set("ay", JSON.stringify(ay));
                this.$session.set("registration_no", JSON.stringify(registration_number));
                // this.$router.push({
                //     name: "student-outstanding-payment-receipt",
                // });
                let routeData = this.$router.resolve({
                    name: "student-outstanding-payment-receipt",
                });
                window.open(routeData.href, "_blank");
            },
            print5(receipt_no, ay) {
                this.receipt_no = receipt_no;
                this.$session.set("receipt_no", JSON.stringify(receipt_no));
                this.$session.set("ay", JSON.stringify(ay));
                let routeData = this.$router.resolve({ name: "transport-receipt" });
                window.open(routeData.href, "_blank");
            },
            print(receipt_no, ay, registration_number) {
                //alert(receipt_no)
                //alert(ay)
                //alert(registration_number)
                this.receipt_no = receipt_no;
                this.$session.set("receipt_no", JSON.stringify(receipt_no));
                this.$session.set("ay", JSON.stringify(ay));
                this.$session.set("registration_no", JSON.stringify(registration_number));
                if (this.org_id == "zeal") {
                    let routeData = this.$router.resolve({ name: "zeal-student-receipt" });
                    window.open(routeData.href, "_blank");
                } else if (this.org_id == "wws") {
                    let routeData = this.$router.resolve({
                        name: "student-fees-receipts-wws",
                    });
                    window.open(routeData.href, "_blank");
                } else if (this.org_id == "uwws") {
                    let routeData = this.$router.resolve({
                        name: "student-fees-receipts-uwws",
                    });
                    window.open(routeData.href, "_blank");
                } else if (this.org_id == "sanjivani") {
                    let routeData = this.$router.resolve({
                        name: "student-fees-receipts-sanjivani",
                    });
                    window.open(routeData.href, "_blank");
                } else if (this.org_id == "desschool") {
                    let routeData = this.$router.resolve({
                        name: "student-fees-receipts-des",
                    });
                    window.open(routeData.href, "_blank");
                } else {
                    let routeData = this.$router.resolve({ name: "student-fees-receipts" });
                    window.open(routeData.href, "_blank");
                }
            },
            getReceiptsData() {
                //alert("date::"+this.selected_date)
                if (this.date_of_generation == "" || this.date_of_generation == null) {
                    this.showSnackbar("#b71c1c", "Please Select Date");
                    return;
                }
                const data = {
                    date: this.date_of_generation,
                    todate: this.application_date,
                    section: this.section,
                    ay: this.ay,
                    standard: this.standard,
                    sort_date_wise: this.sort_date_wise,
                };
                this.overlay = true;
                axios
                    .post("/AccountingAndFees/getReceiptsData", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            // this.student_receipt_details=res.data.student_receipt_details
                            this.student_receipt_details = res.data.student_receipt_details_new;
                            this.components_details_list = res.data.components_details_list;
                            this.out_receipt_details = res.data.out_receipt_details;
                            this.misc_receipt_details = res.data.misc_receipt_details;
                            this.transport_receipt_details = res.data.transport_receipt_details;
                            this.org_basic_data = res.data.org_basic_data;

                            this.show = true;
                        } else {
                            this.showSnackbar("red", res.data.snackbar);
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                        this.overlay = false;
                    })
                    .catch((error) => {
                        this.onerror(error);

                        this.overlay = false;
                    })
                    .finally(() => {
                        this.overlay = false;
                        // this.selected_date=""
                    });
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            formatDate(date) {
                if (!date) return null;
                const [year, month, day] = date.split("-");
                return `${day}/${month}/${year}`;
            },
            parseDate(date) {
                if (!date) return null;
                const [month, day, year] = date.split("/");
                return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
            },
            onerror(error) {
                let msg = "";
                if (error.response) {
                    msg = "Something went wrong.";
                } else if (error.request) {
                    msg = "Please try again.";
                } else {
                    msg = "Un-expected error.";
                }
                this.showSnackbar("error", msg);
            },
            onLoad() {
                axios
                    .post("AccountingAndFees/getReceipts")
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            (this.ay_list = res.data.ay_list), (this.ay = res.data.curreny_ay);
                            // this.section_list = res.data.section_list;
                            this.section_list = [{ id: null, name: "All" },
                                                ...res.data.section_list
                                                ];
                        } else {
                            this.showSnackbar("#b71c1c", res.data.status_reason);
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    })
                    .finally(() => {});
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            dataValueList(column) {
                return [...new Set(this.student_receipt_details.map(item => item[column]))];
            },
        },
        mounted() {
            this.onLoad();
            this.selected_date = this.formatDate(this.date);
            this.to_date = this.formatDate(this.todate);
            this.org_id = localStorage.getItem("EPS-tenant");

            this.date_of_generation = this.formatDate(this.gen_date);
            this.application_date = this.formatDate(this.date_of_application);
        },
        computed: {
            filteredItems() {
                // return this.student_receipt_details.filter((item) => {
                //     return item.name.toLowerCase().indexOf(this.search1.toLowerCase()) > -1 || item.registration_number.toLowerCase().indexOf(this.search1.toLowerCase()) > -1;
                // });
                return this.student_receipt_details.filter(item => {
                const matchesSearch = this.search1
                ? item.name.toLowerCase().includes(this.search1.toLowerCase()) ||
                item.registration_number.toLowerCase().includes(this.search1.toLowerCase())                       
                : true;

                const matchesStd = this.filters.standard.length
                ? this.filters.standard.includes(item.standard)
                : true;

                const matchesDiv = this.filters.division.length
                ? this.filters.division.includes(item.division)
                : true;

                return matchesSearch && matchesStd && matchesDiv;
            });
            },
        },
    };
</script>
<style scoped>
    tr,
    td,
    th {
        border: 1px solid #ccc;
        text-align: center;
        font-size: small;
    }
    tr,
    tbody {
        border-bottom: 1px solid #ccc;
        border: 1px solid #ccc;
        font-size: small;
    }
    td {
        margin: 0.3rem !important;
        padding: 0.4rem !important;
        font-size: small;
    }
    @media (min-width: 320px) {
        td,
        th {
            display: table-cell !important;
            font-size: small;
        }
        td + td,
        th + th {
            width: auto;
            font-size: small;
        }
    }
    v-simple-table {
        white-space: nowrap !important;
        text-align: center;
        font-size: small;
    }

    /* .mytable thead th {
  color: red !important;
} */

    /* v-data-table thead th {
  color: red !important;
} */

    .mytable /deep/ thead th {
        background: #2980b9 !important; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2980b9, #2980b9, #2980b9) !important; /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2980b9, #2980b9, #2980b9) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #2980b9 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
    }
</style>
